var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadFileFilled = function SvgUploadFileFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.692 6.283-3.809-3.808a.624.624 0 0 0-.441-.183H4.167c-.575 0-1.042.466-1.042 1.041v13.334c0 .575.467 1.041 1.042 1.041h11.666c.575 0 1.042-.466 1.042-1.041V6.725a.625.625 0 0 0-.183-.442ZM12.8 11.15a.618.618 0 0 1-.442.183.618.618 0 0 1-.441-.183l-1.292-1.292v3.792a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625V9.858L8.083 11.15a.629.629 0 0 1-.883 0 .629.629 0 0 1 0-.883L9.417 8.05a.825.825 0 0 1 1.158 0l2.217 2.217a.629.629 0 0 1 0 .883h.008Zm0-4.425a.37.37 0 0 1-.367-.367V3.392l3.334 3.333H12.8Z",
    fill: "current"
  })));
};
export default SvgUploadFileFilled;